'use client';

import type { NextPage } from 'next'
import { joinClassnames } from 'helpers/classNames'
import styles from 'styles/Image.module.scss'
import IconAwesomeComponent from 'componentsUnits/iconAwesome'
import { useRouter } from 'next/navigation'
import { MdCancel } from "react-icons/md";

interface Props {
  image: string
  onCloseButton?: () => void
  fullWidth?: boolean
  canClick?: boolean
}
const ImageComponent: NextPage<Props> = (props: Props) => {
  const router = useRouter()
  const className = joinClassnames([
    styles.container,
    props.fullWidth && styles.fullWidth_image,

  ])

  const onImageClick = () => {
    let baseUrl = window.location.origin;
    const url = new URL('imageViewer', baseUrl);
    url.searchParams.set('src', props.image);
    router.push(url.toString())
  }


  return <div className={className}>

    <img
      src={props.image}
      className={styles.image}
      onClick={props.canClick ? onImageClick : undefined}
    />

    {props.onCloseButton
      &&
      <div className={styles.on_image_button}>
        <MdCancel size={25} onClick={props.onCloseButton} />
        {/* <IconAwesomeComponent size="xSmall" type="7" icon={"xmark"} onClick={props.onCloseButton} /> */}
      </div>
    }

  </div>
}

export default ImageComponent
